import React from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import Tag from "./Tag";

interface Props {
  text: string;
  languages: { locale: string; label: string }[];
  selectedLocale: string;
  onLanguageSelected: (locale: string) => void;
}

const LanguageBanner = ({
  text,
  languages,
  selectedLocale,
  onLanguageSelected,
}: Props) => {
  const isBelowSm = useMediaQuery("below", "sm");
  const xsClassName = "my-4 items-start flex-col gap-6 px-4";
  const className =
    "responsive-width mb-12 mt-32 items-center justify-between px-6 gap-12";

  return (
    <div
      className={`flex bg-gray-200 py-4 ${isBelowSm ? xsClassName : className}`}
      data-datocms-noindex
    >
      <p>{text}</p>
      <div className="flex items-start gap-[10px] whitespace-nowrap text-xs">
        {languages.map(({ locale, label }) => (
          <button
            key={locale}
            onClick={() => onLanguageSelected(locale)}
            disabled={locale == selectedLocale}
          >
            <Tag
              key={locale}
              text={label}
              color={locale == selectedLocale ? "gray" : "orange"}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageBanner;
